/* 🤖 this file was generated by svg-to-ts */
export const iconTick: {
  name: 'tick';
  data: string;
} = {
  name: 'tick',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><circle cx="12" cy="12" r="12" fill="#008900"/><path fill="#FFF" d="M10 16a.997.997 0 0 1-.707-.293l-3-3a1 1 0 1 1 1.414-1.414L10 13.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7A.997.997 0 0 1 10 16"/></g></svg>`,
};
